import { memoryStorageService } from "@entrilia/shared/services/storage";
import type { ContactChangesState, NewContactChange } from "./contactChangesState";
import { addNewContactsAction, getInitialContactChangesState } from "./contactChangesState";

const getStorageKey = (investorId: string): string => `contact_changes_${investorId}`;

export const getStoredContactChanges = (investorId: string): ContactChangesState =>
  memoryStorageService.getItemWithFallback(getStorageKey(investorId), getInitialContactChangesState());

export const storeContactChanges = (investorId: string, state: ContactChangesState): void =>
  memoryStorageService.setItem(getStorageKey(investorId), state);

export const addNewContactsToStoredChanges = (
  investorId: string,
  newContacts: NewContactChange[],
  comment: string | undefined
): void =>
  storeContactChanges(investorId, addNewContactsAction(newContacts, comment)(getStoredContactChanges(investorId)));
